const fonts = {
  heading: '"Fira Sans", sans-serif',
  body: '"Fira Sans", sans-serif',
  tooltip: '"Fira Sans", sans-serif',
  mono: '"Inconsolata", monospace',
}

export default fonts
